import './index.scss'
$(".section8 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})